'use client';

import { Apartment } from '@/types/apartment';

const FAVORITES_KEY = 'pacartagena-favorites';

export function getFavorites(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const favorites = localStorage.getItem(FAVORITES_KEY);
    return favorites ? JSON.parse(favorites) : [];
  } catch {
    return [];
  }
}

export function addToFavorites(apartmentId: string): void {
  if (typeof window === 'undefined') return;
  const favorites = getFavorites();
  if (!favorites.includes(apartmentId)) {
    favorites.push(apartmentId);
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  }
}

export function removeFromFavorites(apartmentId: string): void {
  if (typeof window === 'undefined') return;
  const favorites = getFavorites();
  const filtered = favorites.filter(id => id !== apartmentId);
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(filtered));
}

export function isFavorite(apartmentId: string): boolean {
  return getFavorites().includes(apartmentId);
}

export function toggleFavorite(apartmentId: string): boolean {
  if (isFavorite(apartmentId)) {
    removeFromFavorites(apartmentId);
    return false;
  } else {
    addToFavorites(apartmentId);
    return true;
  }
}

export function getFavoritesCount(): number {
  return getFavorites().length;
}